
import React, { useEffect, useRef, useState } from 'react';
import { Tooltip } from '@/components/AntD';

import './index.scss';

export default function EllipsisTitle(props) {
  const { title, ellipsis, className = '', placement } = props;

  const titleRef = useRef(null);

  const [toolTipVisible, setToolTipVisible] = useState(false);

  useEffect(() => {
    getContentWidth();
  }, [title, ellipsis]);

  function getContentWidth() {
    setTimeout(() => {
      const dom = titleRef.current;
      if(!dom) return;
      const { scrollHeight, offsetHeight } = dom;
      setToolTipVisible(scrollHeight > offsetHeight);
    }, 10);
  }

  return <div ref={titleRef} className={`${className} EllipsisTitle line-${ellipsis}`} onClick={getContentWidth}>
    {toolTipVisible ? <Tooltip placement={placement} title={title}><span className="tooltip">{title}</span></Tooltip> : <span>{title}</span>}
  </div>;
}

EllipsisTitle.defaultProps = {
  /** 标题 */
  title: '',
  /** 省略显示的行数 */
  ellipsis: 2,
  className: '',
  placement: 'topLeft'
};